import { Button, IconButton, Tooltip } from "@material-ui/core";
import { MaterialReactTable } from "material-react-table";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Card, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import InfoIcon from "@mui/icons-material/Info";
import "./ManageLicenseKey";
import { getAllLicenseData, getValid } from "../../../Utils/actions";
import { buttonStyle } from "../../../Style/ManualStyle";

function ManageLicenseKey() {
  const [upload, setUpload] = useState(null);
  const [open, setOpen] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const dispatch = useDispatch();

  const { getAllLiceseData, getAllLiceseDataRecord } = useSelector(
    (state) => state.data
  );

  useEffect(() => {
    dispatch(
      getAllLicenseData({
        pageSize: pagination.pageSize,
        pageNumber: pagination.pageIndex + 1,
      })
    );
  }, []);

  useEffect(() => {
    dispatch(
      getAllLicenseData({
        pageSize: pagination.pageSize,
        pageNumber: pagination.pageIndex + 1,
      })
    );
  }, [pagination]);

  const cmpntGroup =
    sessionStorage.getItem("cmpntGroup") !== null
      ? JSON.parse(sessionStorage.getItem("cmpntGroup"))
      : "{}";

  const { t } = useTranslation();

  const columns = useMemo(
    //column definitions...
    () => [
      {
        accessorKey: "name",
        header: "Name ",
        //   editVariant: "select",
        //   editSelectOptions: rigs,
        muiEditTextFieldProps: {
          required: true,
        },
      },
      {
        accessorKey: "status",
        header: "Status",
        //   editVariant: "select",
        //   // filterVariant: "autocomplete",
        //   editSelectOptions: dataProv,
        muiEditTextFieldProps: {
          required: true,
        },
      },
      {
        accessorKey: "user",
        header: "User",
        //   editVariant: "select",
        //   filterVariant: "autocomplete",
        //   editSelectOptions: bUnit,
        muiEditTextFieldProps: {
          required: true,
        },
      },
      {
        accessorKey: "time",
        header: "Time",
        //   editVariant: "select",
        //   filterVariant: "autocomplete",
        //   editSelectOptions: bUnit,
        muiEditTextFieldProps: {
          required: true,
        },
      },
    ],
    [t]
    //end
  );
  const handleFileUpload = async (event) => {
    if (event.target.files.length > 0) {
      setUpload(event.target.files[0]);
      const fileUpload = new FormData();
      fileUpload.append("file", event.target.files[0]);
      console.log("fileUpload====>>>>", fileUpload);
      await dispatch(getValid(fileUpload));
    }
  };

  const modelOpen = () => {
    setOpen(true);
  };

  const modalHideChange = () => {
    setOpen(false);
  };

  const CustomActiveHeader = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        background: "#181818",
      }}
    >
      <Tooltip title="Information">
        <IconButton onClick={modelOpen}>
          <InfoIcon style={{ color: "#c7c7c7" }} />
        </IconButton>
      </Tooltip>
      {cmpntGroup["license"]?.Update || cmpntGroup["license"]?.Add ? (
        <Tooltip title="Upload License">
          <label htmlFor="uploadInput">
            <input
              type="file"
              style={{ display: "none" }}
              onChange={handleFileUpload}
              id="uploadInput"
            />
            <Button
              style={{
                ...buttonStyle,
                // color: "#c7c7c7",
                // border: "transparent",
                // backgroundColor: "#fff",
              }}
              component="span"
              startIcon={<FileUploadIcon />}
            ></Button>
          </label>
        </Tooltip>
      ) : null}
    </div>
  );

  return (
    <Fragment>
      <Card
        className={"shadow-none w-100 data-provider-card"}
        style={{
          backgroundColor: "#333333",
          // backgroundColor: "#dcebfed9",
          padding: "15px",
          overflow: "auto",
          height: "86vh",
          border: "none",
          borderRadius: "unset",
        }}
      >
        <Card.Body
          className={"data_provider_content"}
          style={{
            borderRadius: "0.25rem",
            background: "#242424",
            overflow: "hidden",
            padding: "0px",
          }}
        >
          <div
            className="col-dm-12"
            style={{ display: "block", overflow: "auto" }}
          >
            <div className="col-md-12 data-provider-table">
              <MaterialReactTable
                muiTableHeadCellProps={{
                  sx: {
                    backgroundColor: "#2e2e2e",
                    color: "#ccc",
                  },
                }}
                muiTableHeadProps={{
                  sx: {
                    overflow: "auto",
                    backgroundColor: "#2e2e2e",
                    "&::-webkit-scrollbar": {
                      width: "12px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#444", // darker thumb
                      borderRadius: "6px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      backgroundColor: "#555",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "#2e2e2e",
                    },
                  },
                }}
                muiTableHeadCellContentProps={{
                  sx: {
                    color: "#ccc !important", // text color
                    "& svg": {
                      color: "#ccc !important", // sort icon color
                    },
                  },
                }}
                muiTableBodyProps={{
                  sx: {
                    overflow: "auto",
                    scrollbarWidth: "thin",
                    backgroundColor: "#181818", // dark body
                    "&::-webkit-scrollbar": {
                      width: "12px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#444",
                      borderRadius: "6px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      backgroundColor: "#555",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "#23272f",
                    },
                    "& td": {
                      padding: "0.5rem",
                      borderBottom: "1px solid #333",
                      color: "#c7c7c7",
                    },
                  },
                }}
                muiTabEditIconleHeadCellProps={{
                  sx: {
                    backgroundColor: "#286685",
                    color: "#fff",
                  },
                }}
                muiTableProps={{
                  sx: {
                    overflow: "scroll",
                    border: "none",
                  },
                }}
                muiTableBodyRowProps={({ row, index }) => ({
                  sx: {
                    backgroundColor: row.getIsSelected()
                      ? "bold"
                      : index % 2 === 0
                      ? "#cfd5e959"
                      : "white",
                  },
                })}
                muiTablePaperProps={{
                  sx: {
                    boxShadow: "none",
                    height: "auto",
                    width: "100%",
                    position: "static",
                    display: "block",
                    overflowY: "auto",
                    overflowX: "auto",
                    backgroundColor: "#23272f", // dark table background
                    scrollbarWidth: "thin",
                    "&::-webkit-scrollbar": {
                      width: "12px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#444",
                      borderRadius: "6px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      backgroundColor: "#555",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "#23272f",
                    },
                  },
                }}
                muiPaginationProps={({ table }) => ({
                  count: Math.ceil(
                    getAllLiceseDataRecord / pagination.pageSize
                  ),
                  page: pagination.pageIndex + 1,
                  rowsPerPageOptions: [5, 10, 15, 20, 50], // Define your desired rows per page options
                  rowsPerPage: pagination.pageSize, // Set the current rows per page value
                  showRowsPerPage: false,
                  onChangePage: (event, page) => {
                    table.setPage(page);
                    setPagination({
                      pageIndex: table.nextPage,
                      pageSize: table.getPageCount,
                    });
                  },
                  onChangeRowsPerPage: (event) => {
                    table.setPageSize(parseInt(event.target.value, 10));
                    table.setPage(0); // Reset to the first page when changing rows per page
                    setPagination({
                      pageIndex: table.nextPage,
                      pageSize: table.getPageCount,
                    });
                  },
                })}
                muiTableContainerProps={{
                  sx: {
                    maxHeight: "60vh",
                    backgroundColor: "#181818",
                  },
                }}
                enableStickyFooter={true}
                enableStickyHeader={true}
                columns={columns}
                data={getAllLiceseData}
                enableRowActions={false}
                createDisplayMode="row"
                // positionActionsColumn="last"
                paginationDisplayMode="pages"
                enableFullScreenToggle={false}
                enableFilters={false}
                enableHiding={false}
                enableDensityToggle={false}
                renderTopToolbar={() => <CustomActiveHeader />}
                // manualPagination={true}
                rowCount={getAllLiceseDataRecord}
                // onPaginationChange={setPagination}
                // state={pagination}
              />
            </div>
          </div>
        </Card.Body>
      </Card>
      <div>
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={open}
          onHide={modalHideChange}
          backdrop="static"
          keyboard={false}
          dialogClassName="modal-70w"
          className="license-info"
        >
          <Modal.Header
            style={{
              backgroundColor: "#161616",
              color: "#c7c7c7",
              // position: "sticky",
              // top: 0,
              // zIndex: 1,
            }}
            // closeButton
          >
            <Modal.Title id="contained-modal-title-vcenter">
              License Information
            </Modal.Title>
            <button
              type="button"
              className="close ml-auto modal-header"
              style={{
                color: "white",
                height: "12px",
                width: "12px",
                marginRight: "2px",
              }}
              onClick={modalHideChange}
            >
              &times;
            </button>
          </Modal.Header>
          <Modal.Body>
            <div
              className="col-md-12"
              style={{
                height: "65vh",
                borderLeft: "1px solid black",
                fontSize: "12px",
                backgroundColor: "#333333",
                color: "#c7c7c7",
                overflow: "auto",
                scrollbarColor: "red",
              }}
            >
              <div>
                <h4 className="licence-heading" style={{ paddingTop: "40px" }}>
                  Request Your Personalized License Key
                </h4>
              </div>
              <div
                className="col-md-12 d-flex lincence-content1"
                style={{ paddingTop: "25px" }}
              >
                <ul style={{ paddingLeft: "14px" }}>
                  <li>
                    <p className="jubilant-subtitle">
                      On the page, locate the <b> "Generate License Key" </b>{" "}
                      button and click on it. This button will generate a unique
                      license key.
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      Once the license key is generated, select and copy the
                      generated text.
                    </p>
                  </li>

                  <li>
                    <p className="jubilant-subtitle">
                      Open your email client or webmail service and compose a
                      new email.
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      In the recipient field, enter the email address{" "}
                      <b>support@sigmastream.com</b>
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      In the subject field, provide a descriptive subject line,
                      such as "License Key for [Veras]."
                    </p>
                  </li>
                  <li>
                    {" "}
                    <p className="jubilant-subtitle">
                      In the body of the email, type a message to the recipient.
                      Include instructions for using the license key and any
                      additional information they may need.
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      Include the username in the email body. You can either
                      instruct the user to provide their username in a specific
                      format or retrieve it from a form they filled out on the
                      website.
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      Paste the license key that you copied earlier into the
                      email body.
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      Double-check the email for accuracy, ensuring that the
                      license key and username are correctly included.
                    </p>
                  </li>

                  <li>
                    <p className="jubilant-subtitle">
                      Once you are satisfied with the email content, click the
                      "Send" button to send the email with the license key and
                      username to the recipient.
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      Inform the user that they should check their email for the
                      license key and provide any further instructions if
                      necessary.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer
            style={{
              backgroundColor: "#161616",
            }}
            // className="modal-footer"
          >
            <Button onClick={modalHideChange} style={{ ...buttonStyle }}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </Fragment>
  );
}

export default ManageLicenseKey;
